import axios from 'axios';
import { startLoader, stopLoader } from '../../utils/loader';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    startLoader();
    return config;
  },
  (error) => {
    stopLoader();
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    stopLoader();
    return response;
  },
  (error) => {
    stopLoader();
    
    if (error.response?.status === 401) {
      // Only redirect if not on login/register pages and token exists
      const isAuthPage = window.location.pathname === '/' || 
                         window.location.pathname === '/login' || 
                         window.location.pathname === '/register';
      
      if (!isAuthPage && localStorage.getItem('token')) {
        // Token expired or invalid
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/';
      }
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;
